<template>
    <div class="kf-content">
        <div class="kf-content-navs ">
            <div class="kf-content-nav ">
                <div class="kf-content-nav-icon"></div>
                <div class="kf-content-box ml2">
                    <div class="kf-content-box-title "><div class="kf-content-box-title1-icon mr5"></div>翠鸟·应用中心</div>
                </div>
            </div>
        </div>
        <div class="kf-contents">
            <div class="kf-contents-box">
                <div class="kf-contents-con "
                     v-for="(item,index) in list"
                     :key="index"
                     @click="handleClick(item)">
                    <div class="kf-contents-con-img">
                        <div class="kf-contents-con-img-modal">
                            <!--<div class="modal-i" @click="handleClick(item)"><i class="iconfont icon-Vector"></i></div>-->
                        </div>
                        <img src="../../../styles/img/main-project.png" class="kf-list-img" v-if="item.code=='project'" />
                        <img src="../../../styles/img/main-case.png" class="kf-list-img" v-if="item.code=='case'"  />
                        <img src="../../../styles/img/main-demonstrated.png" class="kf-list-img" v-if="item.code=='demonstrated'"  />
                        <img src="../../../styles/img/main-data.png" class="kf-list-img" v-if="item.code=='data'"  />
                    </div>
                    <div class="kf-contents-con-desc">
                        <i class="iconfont icon-add-bold ml10 mr3"></i>{{item.name}}
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import {computed, onMounted, ref, nextTick} from 'vue'
  import menuModel from '@/model/menu'
  import router from "../../../router";
  export default {
    name: "kf-mainContent",
    setup(){
      const handleClick=function (item) {
        menuModel.updateCurrMenu(item);
      }

      return {
        list:menuModel.menu,
        handleClick
      }
    }
  }
</script>

<style scoped>

</style>